import { NgModule } from '@angular/core';
import { TimePickerComponent } from './time-picker.component';
import {CommonModule, registerLocaleData} from '@angular/common';
import {QuickComponent} from './components/quick/quick.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { RelativeComponent } from './components/relative/relative.component';
import { AbsoluteComponent } from './components/absolute/absolute.component';
import {FormsModule} from '@angular/forms';
import zh from '@angular/common/locales/zh';
registerLocaleData(zh);
@NgModule({
  declarations: [
    TimePickerComponent,
    QuickComponent,
    RelativeComponent,
    AbsoluteComponent
  ],
  imports: [
    CommonModule,
    NzTabsModule,
    FormsModule,
    NzDatePickerModule,
    NzButtonModule,
    NzGridModule,
    NzSelectModule,
    NzInputNumberModule
  ],
  exports: [
    TimePickerComponent,
    QuickComponent,
    RelativeComponent,
    AbsoluteComponent
  ]
})
export class TimePickerModule { }
